import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, RouterProvider, Route } from 'react-router-dom';
import AboutPage from './components/pages/AboutPage';
import ContactPage from './components/pages/ContactPage';
import ReactGA from 'react-ga4';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';

ReactGA.initialize('G-N4TF1JBK2S');
ReactGA.send('pageview');
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: 'about',
    element: <AboutPage />,
  },
  {
    path: 'contact',
    element: <ContactPage />,
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicyPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
